import React from 'react';
import { openImage } from '../../store/chatSlice';
import { useAppDispatch } from '../../store/hooks';

interface ClickableImageThumbnailProps {
  src?: string;
  alt: string;
  className?: string;
  title?: string;
}

const ClickableImageThumbnail: React.FC<ClickableImageThumbnailProps> = ({
  src,
  alt,
  className = '',
  title = 'Click to preview image',
}) => {
  const dispatch = useAppDispatch();

  if (!src) return null;

  const handleOpen = () => {
    dispatch(openImage({ src, type: 'image' }));
  };

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      role="button"
      tabIndex={0}
      title={title}
      onClick={handleOpen}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleOpen();
        }
      }}
    />
  );
};

export default ClickableImageThumbnail;
